import type { Point } from '@/store/models/kop/utils'
import { pointsToRectangle } from '@/store/helpers/utils/kop/pointsToRectangle'
import { calculateRotationAngle } from '@/store/helpers/utils/kop/calculateRotationAngle'
import { Stage as KonvaStage } from 'konva/lib/Stage'

/**
 * Updates the kop item as a horizontal rectangle rotated via `.rotation`
 *
 * @param item - The KOP item object to update (must contain `initial_points`)
 * @param x - New X for endpoint
 * @param y - New Y for endpoint
 * @param stage - Konva stage instance for drawing
 */
export function updateKopItem(item: any, x: number, y: number, stage: KonvaStage): void {
  if (!item?.initial_points || item?.initial_points?.length < 2) {
    console.log('Invalid item points. Must contain at least two values (initial point and second point).')
    return
  }

  const startPoint: Point = [item.initial_points[0], item.initial_points[1]]
  const endPoint: Point = [x, y]
  const height = item.kop_item_shape_height || 0

  // 1. Calculate width based on distance between points
  const dx = endPoint[0] - startPoint[0]
  const dy = endPoint[1] - startPoint[1]
  const width = Math.sqrt(dx * dx + dy * dy)

  // 2. Create a horizontal rectangle starting at (0, 0)
  item.points = pointsToRectangle([0, 0], [width, 0], height)

  // 3. Position the item at startPoint (so (0,0) in local coords maps to this position)
  item.x = startPoint[0]
  item.y = startPoint[1]

  // 4. Set rotation based on direction between start and end points
  item.rotation = calculateRotationAngle(startPoint, endPoint)

  // 5. Pattern fill setup
  // Start pattern at center-left corner
  item.fillPatternX = 0
  // Centered pattern with Y offset due to the drawing "center"
  item.fillPatternY = -(height / 2)

  // 6. Trigger redraw
  stage.batchDraw()
}
